import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../../auth/contexts/AuthContext';

const Navbar = () => {
  const { user, signOut, isAdmin } = useAuth();
  const [isCollapsed, setIsCollapsed] = useState(() => {
    const saved = localStorage.getItem('sidebarCollapsed');
    return saved ? JSON.parse(saved) : false;
  });

  useEffect(() => {
    localStorage.setItem('sidebarCollapsed', JSON.stringify(isCollapsed));
  }, [isCollapsed]);

  const uploadItems = [
    { id: 'wolt', label: 'Wolt', path: '/wolt' },
    { id: 'foodora-upload', label: 'Foodora', path: '/foodora-upload' },
  ];

  const linkClass = ({ isActive }) =>
    `block px-5 py-2.5 text-sm transition-colors ${
      isActive
        ? 'text-black font-medium border-l-2 border-black bg-gray-50'
        : 'text-gray-500 hover:text-black hover:bg-gray-50 border-l-2 border-transparent'
    }`;

  return (
    <>
      {isCollapsed && (
        <button
          onClick={() => setIsCollapsed(false)}
          className="fixed top-1/2 left-0 -translate-y-1/2 z-50 bg-white border border-gray-200 border-l-0 rounded-r-md px-1.5 py-6 text-gray-400 hover:text-black hover:bg-gray-50 transition-colors"
          aria-label="Open sidebar"
        >
          <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
          </svg>
        </button>
      )}

      <nav className={`w-56 shrink-0 border-r border-gray-200 bg-white flex flex-col h-screen sticky top-0 transition-all ${isCollapsed ? 'w-0 overflow-hidden border-r-0' : ''}`}>
        <div className="px-5 py-6 flex items-center justify-between">
          <span className="text-sm font-semibold text-black">Backstube Accounting</span>
          <button
            onClick={() => setIsCollapsed(true)}
            className="text-gray-400 hover:text-black transition-colors"
            aria-label="Close sidebar"
          >
            <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
            </svg>
          </button>
        </div>

        <div className="flex-1 overflow-y-auto py-2">
          <NavLink to="/" className={linkClass} end>
            Dashboard
          </NavLink>

          <div className="mt-4">
            <div className="px-5 pb-1 text-[10px] font-semibold uppercase tracking-widest text-gray-400">
              Uploads
            </div>
            {uploadItems.map((item) => (
              <NavLink key={item.id} to={item.path} className={linkClass}>
                {item.label}
              </NavLink>
            ))}
          </div>

          <div className="mt-4">
            <NavLink to="/vouchers-uploaded" className={linkClass}>
              Vouchers uploaded
            </NavLink>
          </div>
        </div>

        <div className="border-t border-gray-200 p-4 space-y-3">
          {isAdmin && (
            <NavLink to="/members" className={linkClass}>
              Members
            </NavLink>
          )}
          <NavLink to="/settings" className={linkClass}>
            Settings
          </NavLink>
          <div className="px-5 text-xs text-gray-400 truncate">
            {user?.email}
          </div>
          <button
            onClick={signOut}
            className="w-full px-5 py-2 text-xs text-gray-500 hover:text-black text-left transition-colors"
          >
            Sign out
          </button>
        </div>
      </nav>
    </>
  );
};

export default Navbar;
